<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { PromptImage } from '~~/src/types/prompt'
import InitialsAvatar from '~/components/utils/InitialsAvatar/index.vue'
import { cn } from '@/helpers/cn'
const { item, width = 368 } = defineProps<{
  item: PromptImage
  class?: HTMLAttributes['class']
  containerClass?: HTMLElement['className']
  width?: number | false
  alt?: string
  title?: string
}>()

const [src, isLoading] = useProgressiveImage(item.url, width)
const [error, toggleError] = useToggle()
</script>

<template>
  <div :class="[{ 'border-1 border-softGray': isLoading }, cn('overflow-hidden hover:cursor-pointer rounded-2 relative group w-full h-full', containerClass)]">
    <img
      v-if="!error"
      :key="item.id"
      loading="lazy"
      :src="src"
      :class="cn('object-cover transition-property-transform transform-gpu duration-200 delay-100 z-1 w-full h-full', $props.class)"
      :style="{ maxHeight: 'calc(100vh - 96px)' }"
      :alt="alt"
      :title="title"
      @error="toggleError()"
    >
    <InitialsAvatar
      v-else
      :initials="title || 'Image'"
      class="w-full h-full"
    />

    <div v-if="$slots.actionsHover" class="absolute top-0 left-0 w-full h-full  group-hover:visible  invisible z-20">
      <slot name="actionsHover" />
    </div>
    <div v-if="$slots.actions" class="absolute top-0 right-0 z-30">
      <slot name="actions" />
    </div>
  </div>
</template>

<style lang="scss" module>

</style>
